module.exports = __webpack_public_path__ + "img/catchphrase-myfunda.5961802c.png";